import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../Context/Context';

const NumberBetModal = () => {

    const [filteredData, setFilteredData] = useState(null);

    const { allBetModalData, setAllBetModalData, allBetModalStatus, setAllBetModalStatus } = useContext(Context);


    useEffect(() => {
        if (allBetModalStatus) {
            const Data = allBetModalData.filter(item => {
                const value = Object.values(item)[0];
                return value > 0;
            });
            setFilteredData(Data);
        }
    }, [allBetModalStatus, allBetModalData])



    return (
        <div>
            {allBetModalStatus && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <h2>Number and Amount</h2>
                        <ul>
                            {filteredData?.map((item, index) => {
                                const [number, amount] = Object.entries(item)[0];
                                return (
                                    <li key={index}>
                                        <strong>{number}</strong>: ₹{amount}
                                    </li>
                                );
                            })}
                        </ul>
                        <button onClick={() => { setAllBetModalStatus(false); setAllBetModalData(null) }}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NumberBetModal;
